// 提资相关接口
import request from '@/CommonDP/utils/request';
// 获取专业列表
export const carryInfoGetSpecialty = () =>
  request('/carry-info/get-specialty');
// 批量删除提资图层
export const carryInfoDeleteLayers = (data) =>
  request.post('/carry-info/delete-layers', data);
// 批量删除提资图层
export const carryInfoImportAccessFile = (data, config) =>
  request.post('/carry-info/import-access-file', data, config);
// 获取提资图层列表
export const carryInfoGetLayerList = (params) =>
  request('/carry-info/get-layer-list', { params });
export default {
  uploadElectronic(data) {
    return request.post('/uploadElectronic', data, { timeout: 0 });
  },
  // 导入 证书
  uploadSign(data) {
    return request.post('/electronicStamp/uploadSign', data, { timeout: 0 });
  },
  updatesignature(userID) {
    return request.post(`/updatesignature?userID=${userID}`);
  },
  stampDownload(fileID) {
    // 下载
    return request({
      url: `/common/download?fileID=${fileID}`,
      method: 'get',
      responseType: 'blob',
      timeout: 0
    });
  },
  deletesignature(params) {
    return request.post('/deletesignature', params);
  },
  batchUploadsignature(params) {
    return request.post('/batchUpload', params);
  }
};
